import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import {
  isFieldWrong,
  isFormValid
} from "../../common/lib/validationAllFields";
import {
  addNotificationsForInvalidFields,
  focusInvalidField
} from "../lib/validationWeb";
import Spinner from "../components/spinner.react";
import InputWithError from "../components/inputWithError.react";
import Select from "react-select";
import Modal from "../components/modal.react";
import Table from "./table.react";

export default class Users extends Component {
  static propTypes = {
    msg: React.PropTypes.object
  };

  constructor(props) {
    super(props);
    const { users, history } = this.props;
  }

  componentDidMount() {
    const { actions, notificationSystem } = this.props;
    actions.clearForm("users", "createUser");
    actions.getUsers().then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      }
    });
  }

  onFormSubmit = e => {
    e.preventDefault();
    const { actions, users: { forms }, notificationSystem } = this.props;
    actions.createUser(forms.createUser.fields).then(({ error, payload }) => {
      if (error) {
        focusInvalidField(payload, this, "createUser");
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        let notification = {
          level: "success",
          message: "Dodano użytkownika!",
          position: "br",
          autoDismiss: 5,
          dismissible: true
        };
        notificationSystem.addNotification(notification);
        actions.getUsers().then(({ error, payload }) => {
          if (error) {
            addNotificationsForInvalidFields(payload, notificationSystem);
          }
        });
      }
    });
  };

  setGroup = value => {
    const { actions } = this.props;
    actions.setFormField("users", "createUser", "groupName", value);
  };

  onDeleteUser = () => {
    const {
      actions,
      notificationSystem,
      users: { table: { isRemoveUserModalVisible } }
    } = this.props;
    actions.removeUser(isRemoveUserModalVisible).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        let notification = {
          level: "success",
          message: "Usunięto użytkownika!",
          position: "br",
          autoDismiss: 5,
          dismissible: true
        };
        notificationSystem.addNotification(notification);
        actions.getUsers().then(({ error, payload }) => {
          if (error) {
            addNotificationsForInvalidFields(payload, notificationSystem);
          }
        });
      }
    });
    actions.closeRemoveUserModal();
  };

  render() {
    const {
      actions,
      users: { forms, table, table: { isRemoveUserModalVisible } },
      msg: { users: msg }
    } = this.props;

    const createUserFormProps = {
      feature: "users",
      actions: actions,
      form: forms.createUser,
      formName: "createUser",
      msg: msg.forms.createUser,
      validateFormField: actions.validateFormFieldUsers
    };

    const usersSelectOptions = [
      {
        value: "user",
        label: "Użytkownik"
      },
      {
        value: "admin,user",
        label: "Admin"
      },
      {
        value: "developer,admin,user",
        label: "Developer"
      }
    ];

    return (
      <div className="islogged-page">
        <div className="row">
          <div className="col-xs-12">
            <div className="box-wrapper">
              <div className="title">Wszyscy użytkownicy</div>
              <div className="content-wrapper">
                <Table {...this.props} tableWidth={1000} tableHeight={300} />
              </div>
            </div>
            <div className="box-wrapper">
              <div className="title">
                Dodaj nowego użytkownika
                <div className="subtitle">
                  Po dodaniu - użytkownik dostanie maila z instrukcją.
                </div>
              </div>
              <div className="content-wrapper">
                <form onSubmit={this.onFormSubmit} name="createUser" noValidate>
                  <div className="row">
                    <div className="col-xs-12 col-sm-6">
                      <div className="box">
                        <div className="row start-xs middle-xs input-wrapper">
                          <div className="col-xs-3">
                            <div className="box center-with-input">
                              <label htmlFor="email" className="label">
                                Email
                              </label>
                            </div>
                          </div>
                          <div className="col-xs-9 end-xs">
                            <div className="box">
                              <InputWithError
                                field={"email"}
                                {...createUserFormProps}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      <div className="box">
                        <div className="row start-xs middle-xs input-wrapper">
                          <div className="col-xs-3">
                            <div className="box center-with-input">
                              <label htmlFor="group" className="label">
                                Uprawnienia
                              </label>
                            </div>
                          </div>
                          <div className="col-xs-9 end-xs">
                            <div className="box">
                              <Select
                                name="group"
                                value={"user"}
                                searchable={false}
                                noResultsText={"brak wyników"}
                                options={usersSelectOptions}
                                onChange={this.setGroup}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-12 end-xs top-xs">
                      <div className="box">
                        <button
                          className="success submit-button"
                          disabled={
                            forms.createUser.disabled ||
                            !isFormValid(forms.createUser)
                          }
                        >
                          {forms.createUser.disabled && <Spinner />}
                          {!forms.createUser.disabled && "Utwórz"}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {isRemoveUserModalVisible && (
          <Modal
            closeModalAction={actions.closeRemoveUserModal}
            removeAction={this.onDeleteUser}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs">
              <h3>Uwaga!</h3>
              <p>Czy na pewno usunąć?</p>
              <button className="error" onTouchTap={this.onDeleteUser}>
                Tak
              </button>
              <button
                className="info"
                onTouchTap={actions.closeRemoveUserModal}
              >
                Nie
              </button>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/users/Page.react.js